export enum OrderStatus {
  NA,
  New,
  Assigned,
  InProgress,
  Finished,
  ReleaseToClient,
}

export enum LegalCompliance {
  YesOptionLabel,
  NoOptionLabel,
  YesCROptionLabel,
  NAOptionLabel,
  NONE = 999,
}

export enum PhysicalConditions {
  Ambient,
  Chilled,
  Frozen,
  Other,
  NONE = 999,
}
export enum LabelType {
  TrayDisplayOpenCarton,
  ConsumerLabelPrepackedFood,
  OuterCartonLabelB2B,
  OtherLabel,
  OnlineMarketingInformation,
  B2BLabel,
  NONE = 999,
}

export enum RoleType {
  Admin = 'Admin',
  Coordinator = 'Coordinator',
  CompanyUser = 'Company User',
  MultiVendorCustomer = 'Multi Vendor Customer',
  LocalAffiliateCoordinator = 'Local Affiliate Coordinator',
  LimitedAccessCoordinator = 'LimitedAccessCoordinator',
  Reviewer = 'Reviewer',
}

export const PhysicalConditionsData = [
  {
    id: 0,
    description: 'N/A',
  },
  {
    id: 1,
    description: 'Ambient',
  },
  {
    id: 2,
    description: 'Chilled',
  },
  {
    id: 3,
    description: 'Frozen',
  },
  {
    id: 4,
    description: 'Other',
  },
];

export const LegalComplianceData = [
  {
    id: 0,
    description: 'Yes',
  },
  {
    id: 1,
    description: 'No',
  },
  {
    id: 2,
    description: 'Yes CR',
  },
  {
    id: 3,
    description: 'N/A',
  },
];

export const LabalTypeData = [
  {
    id: 0,
    description: 'N/A',
  },
  {
    id: 1,
    description: 'Tray/Display/Open carton',
  },
  {
    id: 2,
    description: 'Consumer Label/Prepacked food',
  },
  {
    id: 3,
    description: 'Outer Carton Label (B2B)',
  },
  {
    id: 4,
    description: 'Other Label',
  },
  {
    id: 5,
    description: 'Online Marketing Information',
  },
  {
    id: 6,
    description: 'B2B Label',
  },
];

//help for actions
export enum ActionInspectionRow {
  View = 'view',
  Edit = 'edit',
  Delete = 'delete',
  NextStep = 'nextstep',
  PrevStep = 'prevstep',
}

//help for type of text input of questionnaire
export enum QuestionnaireTextInputType {
  SGSReview,
  SupplierInfoUpdRev,
  LegislationRef,
}
